module.exports = __webpack_public_path__ + "img/bind_user_info_box_bg.beba06b2.png";